import { render, staticRenderFns } from "./Chart-Bar.vue?vue&type=template&id=4922cd75&scoped=true&"
import script from "./Chart-Bar.vue?vue&type=script&lang=js&"
export * from "./Chart-Bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922cd75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4922cd75')) {
      api.createRecord('4922cd75', component.options)
    } else {
      api.reload('4922cd75', component.options)
    }
    module.hot.accept("./Chart-Bar.vue?vue&type=template&id=4922cd75&scoped=true&", function () {
      api.rerender('4922cd75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/charts/Chart-Bar.vue"
export default component.exports